import { ContainerSimple } from '@app/components/Container'
import type { IContainerSimpleProps } from '@app/components-legacy/Container/ContainerSimple'
import React from 'react'
import { animated, useTransition } from 'react-spring'
import styled from 'styled-components'

interface IContainerOpacityProps extends IContainerSimpleProps {
  name?: string
  fade?: boolean
  // if true, set height: 100%
  fullHeight?: boolean | number
  // if true, set width: 100%
  fullWidth?: boolean | number
}

const ContainerOpacity: React.FC<IContainerOpacityProps> = props => {
  const [show] = React.useState(false)

  const transitions = useTransition([show], 0, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  })

  if (props.fade === false) {
    return (
      <ContainerSimple name={props.name ?? 'ContainerOpacity'} {...props}>
        {props.children}
      </ContainerSimple>
    )
  }

  return (
    <ContainerSimple name={props.name ?? 'ContainerOpacity'} {...props}>
      {transitions.map(t => {
        return (
          <animated.div key={t.key} style={t.props}>
            {props.children}
          </animated.div>
        )
      })}
    </ContainerSimple>
  )
}

export default styled(ContainerOpacity)`
    /* Set height */
    ${props => {
      if (!props.fullHeight) {
        return ''
      }

      const height =
        typeof props.fullHeight === 'number' ? props.fullHeight : 100

      return `
      height: ${height}%;

      > div {
        height: ${height}%;
      }
    `
    }}
        /* Set width */
    ${props => {
      if (!props.fullWidth) {
        return ''
      }

      const width = typeof props.fullWidth === 'number' ? props.fullWidth : 100

      return `
    width: ${width}%;

      > div {
        width: ${width}%;
      }
    `
    }}
`
